/*global jQuery*/
(function($) {
    'use strict';
    var isAuthorized = document.cookie.indexOf('_frontendUser=') !== -1;

    $('.js-header-login-btn').toggleClass('hide', isAuthorized);
    $('.js-header-profile-btn').toggleClass('hide', !isAuthorized);
})(jQuery);
